<template>
  <div>
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditAccountRoleDialog(true)">新增角色</el-button>

    <el-table :data="list" border size="small" style="width: 721px">
      <el-table-column prop="name" label="名称" align="center" width="150">
      </el-table-column>

      <el-table-column label="系统预定义角色" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.isBuiltin" style="color: green">
            是</span>
          <span v-else style="color: red"> 否</span>
        </template>
      </el-table-column>

      <el-table-column label="权限集合" align="left" width="350">
        <template slot-scope="scope">
          <el-input type="textarea" rows="5" v-model="scope.row.privilegesStr" readonly style="width: 330px"></el-input>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <div v-if="$bizutil.hasAnyPrivilege(['account']) && !scope.row.isBuiltin"
            style="display: flex; flex-direction: row; justify-content: center; gap: 10px;">
            <span class="link-button" style="color: red" @click="remove(scope.row)">删除</span>
            <span class="link-button" @click="openEditAccountRoleDialog(false, scope.row)">编辑</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <EditAccountRoleDialog v-if="shouldEditAccountRoleDialogVisible" @close="onEditAccountRoleDialogClosed()"
      :value="valueForEditAccountRoleDialog">
    </EditAccountRoleDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditAccountRoleDialog from "./EditAccountRoleDialog";

export default {
  data() {
    return {
      shouldEditAccountRoleDialogVisible: false, // 编辑对话框是否应该显示出来
      valueForEditAccountRoleDialog: null, // 要传递给编辑对话框的数据
      list: [], // 列表里展示的数据
    };
  },

  async created() {
    // 拉取集合
    this.loadList();
  },

  components: {
    EditAccountRoleDialog,
  },

  methods: {
    /**
     * 查询集合
     */
    async loadList() {
      this.list = [];
      
      for (let e of await this.$bizutil.loadRoles()) {
        this.list.push({
          name: e.name,
          privileges: e.privileges,
          privilegesStr: e.privileges.join("\n"),
          isBuiltin: e.isBuiltin,
        });
      }
    },

    /**
     * 删除
     * @param {*} entry
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除角色：“${entry.name}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/account/manageRoles`,
            {
              action: "delete",
              delete: {
                name: entry.name,
              },
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].name == entry.name) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) { }
    },

    /**
     * 打开编辑对话框
     */
    async openEditAccountRoleDialog(isCreate, oldData) {
      this.shouldEditAccountRoleDialogVisible = true;
      this.valueForEditAccountRoleDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onEditAccountRoleDialogClosed() {
      this.shouldEditAccountRoleDialogVisible = false;

      // 重新拉取集合
      return this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}

::v-deep .el-table .warning-row {
  background: #e7e7e7;
}

.link-button {
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>